import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { first } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';
import { WorkGroup } from '../../models/work-unit.model';

@Injectable()
export class WorkGroupsCoreService {

  constructor(
    protected http: HttpClient,
    @Inject(API_URL) protected apiUrl: string
  ) { }

  get<T>(id?: number) {
    return this.http.get<T>(`${this.apiUrl}/work-group${id ? `/${id}` : ''}`).pipe(first());
  }

  getList({ userId, name }: { userId?: number; name?: string } = {}) {
    return this.http.post<WorkGroup[]>(`${this.apiUrl}/work-group/list`, { userId, name }).pipe(first());
  }

}
